var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"iY_86xLw7eaQcXzlyqgVA"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

// Preproduction and production report to the same Sentry project, so alert rules
// rely on this tag to tell them apart.
const environment = process.env.NEXT_PUBLIC_APP_ENV;

Sentry.init({
  dsn: 'https://ff47fa62775f4d8497c4afe71bc4c3b0@o153522.ingest.sentry.io/5856651',
  environment,
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps

  // Browser-side noise: a request dies because the user closed the tab, navigated
  // away or lost connectivity. Nothing is broken on our side and nothing is
  // actionable, so these never reach Sentry.
  ignoreErrors: [
    // Fetch failures and aborts, using the wording emitted by supported engines.
    /^Failed to fetch$/,
    /^NetworkError when attempting to fetch resource\.?$/,
    /^Load failed$/,
    /^AbortError$/,
    /^The user aborted a request\.?$/,
    /^The operation was aborted\.?$/,
    // Benign layout notification browsers report as an error.
    /^ResizeObserver loop limit exceeded$/,
    /^ResizeObserver loop completed with undelivered notifications\.?$/,
  ],
  // Errors thrown by a visitor's browser extension, never by our code.
  denyUrls: [
    /^chrome-extension:\/\//i,
    /^chrome:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-(web-)?extension:\/\//i,
  ],
});
